import React, { useState, useEffect } from 'react'

import { useHistory } from 'react-router-dom'

import EditHeaderContractor from '../../../../../../presentation/pages/contractors/profile/edit-header'

import { useMe } from '../../../../../../presentation/contexts/me'

import { makeContractors } from '../../../../../usecases/contractors/remote-contractors-factory'
import { makeUpdateUser } from '../../../../../usecases/update-user/remote-update-user-factory'

import IContractor from '../../../../../../presentation/interfaces/contractor'

const MakeEditHeaderContractor = () => {
  document.title = 'BuscarMédicos - Perfil'

  const [headerInfo, setHeaderInfo] = useState<Partial<IContractor>>({
    corporateName: '',
    imgUrl: '',
    email: '',
    phone: '',
    document: [],
  })

  const [errorMessage] = useState<string | null>('')

  const history = useHistory()

  const { me } = useMe()

  useEffect(() => {
    const loadContractor = async () => {
      try {
        if (!me) {
          return
        }

        const data = await makeContractors().loadById(me.id as number)
        setHeaderInfo(data)
      } catch (error) {
        console.error(error)
      }
    }

    loadContractor()
  }, [me])

  const dataForm = [
    {
      items: [
        {
          name: 'corporateName',
          component: 'Input',
          value: headerInfo.corporateName,
          placeholder: 'Digite aqui',
          type: 'text',
          title: 'Razão Social',
          label: 'Razão Social',
          stylesContainer: { marginBottom: '15px' },
        },
        {
          name: 'email',
          component: 'Input',
          value: headerInfo.email,
          placeholder: 'Digite aqui',
          type: 'email',
          title: 'E-mail',
          label: 'E-mail',
          style: { marginBottom: '15px' },
        },
        {
          name: 'phone',
          component: 'InputPhone',
          value: headerInfo.phone,
          placeholder: 'Digite aqui',
          type: 'tel',
          title: 'WhatsApp',
          label: 'WhatsApp',
          style: { marginBottom: '15px' },
        },
        {
          name: 'button',
          component: 'Button',
          title: 'Salvar alterações',
          submittingText: 'Carregando...',
          color: true,
        },
      ],
    },
  ]

  const onSubmit = async (data: any) => {
    const { corporateName, email, phone } = data

    try {
      const changedFields: any = {}
      if (corporateName !== headerInfo.corporateName) {
        changedFields.corporateName = corporateName
      }
      if (email !== headerInfo.email) {
        changedFields.email = email
      }
      if (phone !== headerInfo.phone) {
        changedFields.phone = phone
      }

      if (Object.keys(changedFields).length > 0) {
        await makeUpdateUser().update(Number(me?.id), changedFields)

        setHeaderInfo((prev) => ({ ...prev, ...changedFields }))
        history.goBack()
      }
    } catch (error) {
      console.error(error)
    }
  }

  const props = {
    headerInfo: {
      ...headerInfo,
      imgUrl: headerInfo.document?.find((doc: any) => doc.url.startsWith('images/'))?.url,
    },
    onSubmit,
    dataForm,
    errorMessage,
  }

  return <EditHeaderContractor {...props} />
}

export default MakeEditHeaderContractor
